var map = {
	"./appAsset-brand--getnet.svg": "a501",
	"./appAsset-brand--khipu.svg": "d713",
	"./appAsset-brand--mercadopago.svg": "b613",
	"./appAsset-brand--oneclick.svg": "8fd3",
	"./appAsset-brand--paypal.svg": "ede7",
	"./appAsset-brand--stripe.svg": "4984",
	"./appAsset-brand--twocheckout.svg": "eb0e",
	"./appAsset-brand--webpay.svg": "5228"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e4d1";